import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient.js";
import { getErrorMessage } from "#/utils/APIUtils.js";

const baseUrl = "/api/rkg/vw-subjekt-odgovorni-subjekt-osebe";

export const fetchSubjectResponsibleInstitutionUserRelationship =
  createAsyncThunk(
    "subjectResponsibleInstitutionUserRelationship/list",
    async (id, { rejectWithValue }) => {
      try {
        const response = await ApiClient.get(`${baseUrl}/${id}`);
        return response.data;
      } catch (error) {
        return rejectWithValue(getErrorMessage(error));
      }
    }
  );

export const fetchSubjectResponsibleInstitutionUserRelationshipPage =
  createAsyncThunk(
    "subjectResponsibleInstitutionUserRelationship/page",
    async ({ page, filter, sort }, { rejectWithValue }) => {
      try {
        const response = await ApiClient.get(
          `${baseUrl}/page`,
          undefined,
          page,
          filter,
          sort,
          false
        );
        return response.data;
      } catch (error) {
        return rejectWithValue(getErrorMessage(error));
      }
    }
  );

export const fetchSubjectResponsibleInstitutionUserRelationshipBySubjectIds =
  createAsyncThunk(
    "subjectResponsibleInstitutionUserRelationship/bySubjectIds",
    async (subjektId, nivoDostopa, { rejectWithValue }) => {
      try {
        const response = await ApiClient.get(
          `${baseUrl}/by-subjekt-and-nivo-dostopa`,
          { subjektId, nivoDostopa }
        );
        return response.data;
      } catch (error) {
        return rejectWithValue(getErrorMessage(error));
      }
    }
  );

const SubjectResponsibleInstitutionUserRelationshipSlice = createSlice({
  name: "subjectResponsibleInstitutionUser",
  initialState: {
    list: [],
    page: {},
    filteredList: [],
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    /* List */
    builder
      .addCase(
        fetchSubjectResponsibleInstitutionUserRelationship.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.list = action.payload;
        }
      )
      .addCase(
        fetchSubjectResponsibleInstitutionUserRelationship.rejected,
        (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        }
      )
      .addCase(
        fetchSubjectResponsibleInstitutionUserRelationship.pending,
        (state, _) => {
          state.isLoading = true;
          state.error = null;
        }
      );
    /* Page */
    builder
      .addCase(
        fetchSubjectResponsibleInstitutionUserRelationshipPage.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.page = action.payload;
        }
      )
      .addCase(
        fetchSubjectResponsibleInstitutionUserRelationshipPage.rejected,
        (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        }
      )
      .addCase(
        fetchSubjectResponsibleInstitutionUserRelationshipPage.pending,
        (state, _) => {
          state.isLoading = true;
          state.error = null;
        }
      );
    /* Filtered by subject id and nivo dostopa */
    builder
      .addCase(
        fetchSubjectResponsibleInstitutionUserRelationshipBySubjectIds.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.filteredList = action.payload;
        }
      )
      .addCase(
        fetchSubjectResponsibleInstitutionUserRelationshipBySubjectIds.rejected,
        (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        }
      )
      .addCase(
        fetchSubjectResponsibleInstitutionUserRelationshipBySubjectIds.pending,
        (state, _) => {
          state.isLoading = true;
          state.error = null;
        }
      );
  },
});

export default SubjectResponsibleInstitutionUserRelationshipSlice.reducer;
